import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomIcon from 'components/base/CustomIcon';
import { OtherTypes } from 'components/base/CustomIcon/types';
import './index.scss';
import { NoData } from 'components/base/NoData';

interface IPrivacityCell {
  publishCeremony: boolean;
  publishVigil: boolean;
  ageConfidential: boolean;
}
export const PrivacityCell: FC<IPrivacityCell> = (
  { ageConfidential, publishCeremony, publishVigil },
) => {
  const { t } = useTranslation();
  const [publicInfoList, setPublicInfoList] = useState<Array<string>>([]);
  const [privateInfoList, setPrivateInfoList] = useState<Array<string>>([]);

  useEffect(
    () => {
      const publicInfo = [];
      const privateInfo = [];

      if (ageConfidential) {
        privateInfo.push(t('common.age'));
      } else {
        publicInfo.push(t('common.age'));
      }

      if (publishCeremony) {
        publicInfo.push(t('service.ceremony.ceremony'));
      } else {
        privateInfo.push(t('service.ceremony.ceremony'));
      }

      if (publishVigil) {
        publicInfo.push(t('service.vigil.vigil'));
      } else {
        privateInfo.push(t('service.vigil.vigil'));
      }

      setPublicInfoList(publicInfo);
      setPrivateInfoList(privateInfo);
    },
    [ageConfidential, publishCeremony, publishVigil, t],
  );

  return (
    <div className="f-privacy-cell">
      <div>
        <CustomIcon className="forbidden-icon" icon={OtherTypes.FORBIDEN} />
        {privateInfoList.length
          ? privateInfoList.map((privateItem) => (<div key={`forbidden-${privateItem}`} className="info-label">{privateItem}</div>))
          : <NoData />}
      </div>
      <div>
        <CustomIcon className="public-icon" icon={OtherTypes.VALID} />
        {publicInfoList.length
          ? publicInfoList.map((publicItem) => (<div key={`public-${publicItem}`} className="info-label">{publicItem}</div>))
          : <NoData />}
      </div>
    </div>
  );
};
